/* tslint:disable */
/* eslint-disable */
/* @relayHash 45a833fbd9b2c05a890cade9b0a1bde2 */

import { ConcreteRequest } from "relay-runtime";
export type CreateDSAReportInput = {
    commentID: string;
    userID?: string | null;
    lawBrokenDescription: string;
    additionalInformation: string;
    submissionID?: string | null;
    commentRevisionID?: string | null;
    clientMutationId: string;
};
export type CreateDSAReportMutationVariables = {
    input: CreateDSAReportInput;
};
export type CreateDSAReportMutationResponse = {
    readonly createDSAReport: {
        readonly dsaReport: {
            readonly id: string;
            readonly lawBrokenDescription: string;
        } | null;
        readonly clientMutationId: string;
    };
};
export type CreateDSAReportMutation = {
    readonly response: CreateDSAReportMutationResponse;
    readonly variables: CreateDSAReportMutationVariables;
};



/*
mutation CreateDSAReportMutation(
  $input: CreateDSAReportInput!
) {
  createDSAReport(input: $input) {
    dsaReport {
      id
      lawBrokenDescription
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = [
        ({
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "CreateDSAReportPayload",
            "kind": "LinkedField",
            "name": "createDSAReport",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "DSAReport",
                    "kind": "LinkedField",
                    "name": "dsaReport",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lawBrokenDescription",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "CreateDSAReportMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "CreateDSAReportMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "id": "45a833fbd9b2c05a890cade9b0a1bde2",
            "metadata": {},
            "name": "CreateDSAReportMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '3a87f9b155a2ca4327171f8d36c60dc2';
export default node;
